import { createElement } from 'react';
import { DialogProps } from '.';
import { BaseDialog } from './__internal__';

export const Dialog = (props: DialogProps) => <BaseDialog {...props} />;
